import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConCamp } from '../con-camp/con-camp';
import { AccountService } from '../../../services/account.service';
import { GestCom } from '../gest-com/gest-com';
import { NavNotas } from '../nav-notas/nav-notas';
import { Activities } from '../../activities/activities';

interface NavItem{
  item: number,
  name: string,
  active: boolean
}

interface Contacto{
  item: number,
  name: string,
  company: string
}

@Component({
  selector: 'app-nav-account',
imports: [CommonModule, RouterModule, GestCom, ConCamp, NavNotas, Activities],  
templateUrl: './nav-contact.html',
  styleUrl: './nav-contact.css'
})
export class NavContact {
    @Input() contacto: any;

  public accService = inject(AccountService);
  showItem2: boolean = true;

  public navItems: NavItem[] = [
    {item: 0, name: "Actividad", active: true},
    {item: 1, name: "Gestion comercial", active: false},
    {item: 2, name: "Contratos y campañas", active: false},
    {item: 3, name: "Archivos", active: false},
    
  ] 

  triggerAction(action:number){
    for (let i = 0; i < this.navItems.length; i++) {
      if(i == action){
        this.navItems[i].active = true;
      }else{
        this.navItems[i].active = false;
      }
    }

    // if(action === 2){
    //   this.navItems[2].active = true;
    //   this.showItem2 = true;
    //   // const data: Contacto [] = [
    //   //   {name:"Marcelo", item:1, company:"Nvidia"},
    //   //   {name:"Pedro", item:2, company:"McDonald"},
    //   //   {name:"Miguel", item:3, company:"ElGato"}
    //   // ]
    //   // this.accService.setTableData(data);
    // }if(action === 3){

    // }
  }
}
